import {Button} from '@/components/ui/button/Button'
import {
    Dialog,
    DialogBody,
    DialogDisclosure,
    DialogDismiss,
    DialogProvider
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Trash01Icon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {useDeleteReferringSpecialist} from '../../queries/useDeleteReferringSpecialist'
import {errorHandler} from '@/utilities/helpers'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {StyledDeleteBudgetFooter} from './style'

export const DeleteReferringSpecialist = ({id}: {id: string}) => {
    const {t} = useTranslation()
    const deleteReferringSpecialist = useDeleteReferringSpecialist({onError: errorHandler})

    return (
        <DialogProvider>
            <DialogDisclosure
                render={<Button className="show-on-hover" size="xs" shape="square" variant="secondary" />}
            >
                <Trash01Icon />
            </DialogDisclosure>
            <Dialog width="400px">
                <DialogBody gap={2}>
                    <Text render="h1" size="textXl" weight={'500'}>
                        {t('referring_specialist:delete_title')}
                    </Text>
                    <Text size="textSm" palette="neutral" shade="600">
                        {t('referring_specialist:delete_description')}
                    </Text>
                </DialogBody>
                <StyledDeleteBudgetFooter>
                    <DialogDismiss render={<Button variant="secondary">{t('commons:cancel')}</Button>} />
                    <Button
                        variant="primaryDanger"
                        onClick={() => deleteReferringSpecialist.mutate(id)}
                        disabled={deleteReferringSpecialist.isPending}
                    >
                        {t('commons:delete')}
                        {deleteReferringSpecialist.isPending && <Spinner />}
                    </Button>
                </StyledDeleteBudgetFooter>
            </Dialog>
        </DialogProvider>
    )
}
